"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteDrinkCard = deleteDrinkCard;
exports.getDishGroupList = getDishGroupList;
exports.getDrinkCardDetail = getDrinkCardDetail;
exports.getDrinkCardItemChangeLogs = getDrinkCardItemChangeLogs;
exports.getDrinkCardPage = getDrinkCardPage;
exports.saveDrinkCard = saveDrinkCard;
exports.updateDrinkCardStatus = updateDrinkCardStatus;
exports.uploadImage = uploadImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getDrinkCardPage(params) {
  return (0, _requestAuth.default)({
    url: '/drinkCard/page',
    method: 'get',
    params: params
  });
}
function getDrinkCardDetail(id) {
  return (0, _requestAuth.default)({
    url: '/drinkCard/' + id,
    method: 'get'
  });
}
function saveDrinkCard(data) {
  return (0, _requestAuth.default)({
    url: '/drinkCard/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function updateDrinkCardStatus(data) {
  return (0, _requestAuth.default)({
    url: '/drinkCard/updateStatus',
    method: 'post',
    data: data
  });
}
function deleteDrinkCard(id) {
  return (0, _requestAuth.default)({
    url: '/drinkCard?id=' + id,
    method: 'delete'
  });
}
function uploadImage(data) {
  return (0, _requestAuth.default)({
    url: '/image/upload',
    method: 'post',
    data: data
  });
}
function getDishGroupList(params) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/page',
    method: 'get',
    params: params
  });
}
function getDrinkCardItemChangeLogs(ruleId) {
  return (0, _requestAuth.default)({
    url: '/drinkCardItem/changeLogs',
    method: 'get',
    params: {
      ruleId: ruleId
    }
  });
}